import { Post } from './post';

export class PostsState {
  nextOffset?: number;

  posts: {
    [id: string]: Post;
  };
}
